import { useCallback, useEffect, useRef, useState } from "react";
import { api } from "../lib/api";
import { buildListingQuery } from "./useBrowseListings";

// Appends pages 2..N to the first page of results; resets whenever filters change.
export function useAppendPages(params, res, enabled) {
  const baseKey = buildListingQuery(params, 1);
  const [more, setMore] = useState({ key: baseKey, items: [], next: 2 });
  const [loading, setLoading] = useState(false);
  const busy = useRef(false);
  useEffect(() => { setMore({ key: baseKey, items: [], next: 2 }); busy.current = false; setLoading(false); }, [baseKey]);

  const loadMore = useCallback(() => {
    if (!enabled || busy.current || res.loading || more.key !== baseKey || more.next > res.pages) return;
    busy.current = true;
    setLoading(true);
    const page = more.next;
    api.get(`/listings?${buildListingQuery(params, page)}`)
      .then(({ data }) => setMore((m) => {
        if (m.key !== baseKey) return m;
        const seen = new Set([...res.items, ...m.items].map((l) => l.id));
        return { key: baseKey, items: [...m.items, ...data.items.filter((l) => !seen.has(l.id))], next: page + 1 };
      }))
      .catch(() => {})
      .finally(() => { busy.current = false; setLoading(false); });
  }, [enabled, res.loading, res.pages, res.items, more, baseKey, params]);

  const items = more.key === baseKey ? [...res.items, ...more.items] : res.items;
  return { items, loadMore, loading, hasMore: more.key === baseKey && more.next <= res.pages };
}
